import { InferType, object, string } from 'yup';

import { PHONE_REGEXP, STRONG_EMAIL_REGEXP } from '@/utils/constants';

export const basicInquiryFormSchema = object({
  firstName: string().trim().required('firstname-required'),
  lastName: string().trim().required('lastname-required'),
  email: string()
    .trim()
    .required('email-required')
    .email('email-invalid')
    .matches(STRONG_EMAIL_REGEXP, 'email-invalid'),
  phone: string()
    .trim()
    .required('phone-required')
    .matches(PHONE_REGEXP, 'phone-invalid'),
  company: string().trim().required('company-required'),
  comments: string(),
}).required();

export type BasicInquiry = InferType<typeof basicInquiryFormSchema>;

// match to translation keys and url paths
export enum ContactOptions {
  Workspace = 'workspace',
  RealEstate = 'real-estate',
  Marketing = 'marketing',
  Partnerships = 'partnerships',
  MeetingRoom = 'meeting-space',
  PrAndMedia = 'pr-and-media',
  General = 'general',
}
